import { useTranslation } from 'react-i18next';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { formatAuthorName } from 'utils/formatters';

import s from './styles.module.scss';

import type { FC } from 'react';
import type { SmsCampaignLogin } from 'infrastructure/interfaces';

interface AuthorNameProps {
  author: SmsCampaignLogin;
  isCreatedBy?: boolean;
  date?: string | null;
}

const AuthorName: FC<AuthorNameProps> = ({ author, date, isCreatedBy }) => {
  const { t } = useTranslation();
  const label = isCreatedBy ? t('labels.createdBy') : t('labels.lastUpdatedBy');

  return (
    <p className={s['created-updated']}>
      {label}:
      <span className={s['created-updated-name']}>
        {formatAuthorName(author)}
      </span>
      <span>|</span>
      <span className={s['created-updated-date']}>
        {DateFormatter({
          date: date ?? '',
          format: DateFormats['MM-dd-yy'],
        })}
      </span>
    </p>
  );
};
export default AuthorName;
